import { render, staticRenderFns } from "./Argolas.vue?vue&type=template&id=af5e4d96&"
import script from "./Argolas.vue?vue&type=script&lang=js&"
export * from "./Argolas.vue?vue&type=script&lang=js&"
import style0 from "./Argolas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports